import { jsxs, jsx } from "react/jsx-runtime";
import { Checkbox, TextField, TextFieldTheme } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useMemo, useState, useEffect, useCallback } from "react";
import { debounce } from "ts-debounce";
import { useTranslation } from "../../contexts/translation-context.js";
import { getOptionsValues, getIsOtherOptionSelected, getOtherValue, getOtherLabel, OTHER_ID } from "../../ui/checkbox-group-field/checkbox-group-field-utils.js";
import styles from "../../ui/checkbox-group-field/checkbox-group-field-wut.module.scss";
import { classes } from "../../ui/checkbox-group-field/checkbox-group-field-wut.st.css";
const OtherOptionWUT = ({
  label,
  options,
  addOther,
  addOtherLabel,
  addOtherPlaceholder,
  minLength,
  maxLength,
  value = null,
  onChange,
  disabled,
  hasError
}) => {
  const _value = useMemo(() => value || [], [value]);
  const optionsValues = useMemo(() => getOptionsValues(options), [options]);
  const isOtherOptionSelected = getIsOtherOptionSelected(_value, optionsValues);
  const [otherSelected, setOtherSelected] = useState(isOtherOptionSelected);
  const [otherValue, setOtherValue] = useState(
    isOtherOptionSelected ? getOtherValue(_value, addOtherLabel) : ""
  );
  useEffect(() => {
    setOtherSelected(isOtherOptionSelected);
    setOtherValue(
      isOtherOptionSelected ? getOtherValue(_value, addOtherLabel) : ""
    );
  }, [isOtherOptionSelected, _value, addOtherLabel]);
  const { t } = useTranslation();
  const otherLabel = getOtherLabel(addOtherLabel, t);
  const otherOptionCheckboxChange = (event) => {
    setOtherSelected(event.checked);
    setOtherValue("");
    handleOtherChange(event.checked ? `${otherLabel}` : "");
  };
  const handleOtherChange = useCallback(
    (newValue) => {
      const removedOther = _value.filter(
        (val) => optionsValues.includes(val)
      );
      const _newValue = newValue.length > 0 ? [...removedOther, newValue] : removedOther;
      onChange(_newValue);
    },
    [onChange, optionsValues, _value]
  );
  const handleOtherInputChange = (event) => {
    const input = event.target.value;
    const _otherValue = input ? `${addOtherLabel}: ${input}` : otherLabel;
    setOtherValue(input);
    setOtherSelected(true);
    debouncedHandleOtherChange(_otherValue);
  };
  const debouncedHandleOtherChange = useMemo(() => {
    return debounce(handleOtherChange, 500);
  }, [handleOtherChange]);
  if (!addOther) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: classes.otherContainer, children: [
    /* @__PURE__ */ jsx(
      Checkbox,
      {
        checked: otherSelected,
        onChange: otherOptionCheckboxChange,
        label: otherLabel,
        name: label,
        disabled,
        error: hasError,
        className: classNames(classes.checkbox, styles.checkbox, {
          [styles.checkboxError]: hasError
        })
      },
      `checkbox-${OTHER_ID}`
    ),
    otherSelected && /* @__PURE__ */ jsx(
      TextField,
      {
        className: classNames(classes.otherInput, classes.theme),
        value: otherValue,
        placeholder: addOtherPlaceholder,
        minLength,
        maxLength,
        onChange: handleOtherInputChange,
        disabled,
        error: hasError,
        theme: TextFieldTheme.Box,
        showCharCount: Boolean(maxLength),
        "aria-label": otherLabel
      }
    )
  ] });
};
export {
  OtherOptionWUT
};
//# sourceMappingURL=other-option-wut.js.map
